import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=27f1ad0a&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=27f1ad0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1ad0a",
  null
  
)

export default component.exports